import React, { useEffect } from 'react';
import mapIcon from '../../assets/images/common/mapIcon.png';
import './Map.css';

const Map = () => {

  useEffect(() => {
    const container = document.getElementById('map');
    const options = {
      center: new window.kakao.maps.LatLng(37.5464137, 127.0658306),
      level: 2,
      mapTypeId : window.kakao.maps.MapTypeId.ROADMAP
    };
    const map = new window.kakao.maps.Map(container, options);

    const imageSrc = mapIcon // 마커이미지의 주소입니다    
    const imageSize = new window.kakao.maps.Size(52, 89) // 마커이미지의 크기입니다
    const imageOption = {offset: new window.kakao.maps.Point(27, 69)};

    const markerPosition  = new window.kakao.maps.LatLng(37.5464137, 127.0658306); 
    const markerImage = new window.kakao.maps.MarkerImage(imageSrc, imageSize, imageOption);
    
    const content = '<div class="customoverlay">' +
    '  <a href="https://map.kakao.com/?itemId=457468447" target="_blank">' +
    '    <span class="title">엠포플러스(주)</span>' +
    '  </a>' +
    '</div>';

    var marker = new window.kakao.maps.Marker({
      position: markerPosition,
      image: markerImage // 마커이미지 설정 
    });

    marker.setMap(map); 

    // const marker = new window.kakao.maps.Marker({
    //   position: markerPosition,
    //   map: map,
    //   content: content,
    //   image: markerImage,
    // });

    var position = new window.kakao.maps.LatLng(37.5464137, 127.0658306);  

    const customOverlay = new window.kakao.maps.CustomOverlay({
        map: map,
        position: position,
        content: content,
        xAnchor: 0.5, // 컨텐츠의 x 위치
			  yAnchor: 4 // 컨텐츠의 y 위치
    });

  }, []);

  return <div id="map" style={{ width: '100%', height: '100%' }}></div>;

}

export default Map;
